import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import { __constants, __snackBarSeverity } from '../../constants';
import moment from 'moment';
import mainContext from '../../contexts/mainContext';
import { getHelpSupportListing, updateHelpSupportStatus } from '../../Controllers/Help&Support';
import styled from '@emotion/styled';
import { Button, Divider, Pagination } from '@mui/material';
import SearhcBar from './SearchBar';
import { Support } from '@mui/icons-material';
import SupportDetail from './SupportDetail';

export default function HelpSupportList() {
  const { setSnackBar, setProfileNavTitle, setPageload } = React.useContext(mainContext); /* App State */
  const [state, setState] = useState({ /* Component State */
    support: {},
    total: 0,
    page: 1,
    limit: 8,
    index: -1,
    selectedSupport: {},
    openDetails: false
  })
  const [filterState, setFilterState] = React.useState({});
  const [searchParams] = useSearchParams()
  const autoOpenSupportNo = searchParams.get("supportNo") /* Set by the ops notification email link */

  useEffect(() => {
    setProfileNavTitle("Help & Support") /* Set TopNav Title */
    if (autoOpenSupportNo) {
      setFilterState({ query: autoOpenSupportNo })
      fetchTickets(state.page, false, autoOpenSupportNo)
    } else {
      fetchTickets(state.page)
    }
    // eslint-disable-next-line
  }, [])

  const callSnackBar = (msg, type) => { /* Alert for User */
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type]
    });
  }

  const fetchTickets = async (page, isClear, autoOpenNo) => { /* Get Categories and sub categories */
    setPageload(true)
    let params = { page }
    if (!isClear)
      params = { page, ...filterState }
    if (autoOpenNo)
      params = { page, query: autoOpenNo }
    const res = await getHelpSupportListing(params)
    setPageload(false)
    if (res.data.status === 200) {
      let newList = {}
      res.data.data.support.forEach((object) => {
        let date = moment(object.createdAt).format('YYYY-MM-DD')
        newList[date] = newList[date] ? newList[date] : []
        newList[date].push(object)
      })
      const ticket = autoOpenNo && res.data.data.support.find((object) => object.supportNo === autoOpenNo)
      if (ticket) { /* Open the ticket's details, marking it as read the same way "View" does */
        if (ticket.status === "Unread") {
          const statusRes = await updateHelpSupportStatus(ticket._id, { status: "Unresolved" })
          if (statusRes.data.status === 200) ticket.status = "Unresolved"
        }
        const index = newList[moment(ticket.createdAt).format('YYYY-MM-DD')].indexOf(ticket)
        setState({ ...state, support: newList, total: res.data.data.total, openDetails: true, selectedSupport: ticket, index })
        return
      }
      setState({ ...state, support: newList, total: res.data.data.total })
    } else {
      callSnackBar(res.data.errors[0].message, "error")
    }
  }

  const handleStatus = async (index, status, data) => {
    if (data.status === "Unread") {
      const res = await updateHelpSupportStatus(data._id, { status })
      if (res.data.status === 200) {
        let newDate = moment(data.createdAt).format('YYYY-MM-DD')
        let temp = { ...state.support }
        temp[newDate][index].status = status
        setState({ ...state, support: temp })
        handleView(data, index)
      } else {
        callSnackBar(res.data.errors[0].message, "error")
      }
    } else {
      handleView(data, index)
    }
  }

  const handleView = (data, index) => {
    setState({ ...state, openDetails: true, selectedSupport: data, index: index })
  }

  const handleCb = (status, date, index) => {
    let newDate = moment(date).format('YYYY-MM-DD')
    let temp = { ...state.support }
    temp[newDate][index].status = status
    setState({ ...state, support: temp, openDetails: false })
  }

  return (
    <>
      <SearhcBar filterState={filterState} setFilterState={setFilterState} callFunction={fetchTickets} />
      <Container className='scrollbar'>
        <Body>
          {Object.entries(state.support).map((list) =>
            <>
              <Date>{moment(list[1][0].createdAt).format("DD MMM, YYYY")}</Date>
              <Divider className='divider-gap' />
              <List>
                <div className="header">Status</div>
                <div className="header">Support No.</div>
                <div className="header">Category</div>
                <div className="header">Sub-category</div>
                <div className="header">Role</div>
                <div className="header">Email</div>
                <div className="header">Comment</div>
              </List>
              <Divider className='divider-gap' />
              {list[1].map((object, index) =>
                <>
                  <List key={object._id}>
                    <div>
                      <div className={object.status === "Unread" ? "list_card_status status_inactive" : object.status === "Resolved" ? "list_card_status status_active" : "list_card_status status_sleeping"}>{object.status}</div>
                    </div>
                    <div>
                      {object.supportNo}
                    </div>
                    <div>
                      {object.category}
                    </div>
                    <div>
                      {object.subCategory}
                    </div>
                    <div>
                      {object.userInfo.role}
                    </div>
                    <div>
                      {object.userInfo.email}
                    </div>
                     <div>
                      {object.description.length > 10 ? object.description.substring(0, 15) + "..." : object.description}
                    </div>
                    <button className="list_card_view_btn" onClick={() => { handleStatus(index, "Unresolved", object) }}>View</button>
                  </List>
                </>
              )}

              <Divider className='divider-gap' />
            </>
          )}
          {Object.entries(state.support).length === 0 && <div className='no-record'><span>No Record Found</span></div>}
        </Body>
      </Container>
      {
        Object.entries(state.support).length > 0 &&
        <>
          <Pagination count={Math.ceil(state.total / __constants.listingLimit)} color="primary" shape="rounded" onChange={(e, page) => { fetchTickets(page) }} />
          <br />
        </>
      }

      <SupportDetail
        open={state.openDetails}
        handleClose={() => setState({ ...state, openDetails: false })}
        data={state.selectedSupport}
        cb={handleCb}
        index={state.index}
      />
    </>
  )
}

const Container = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
  overflow-x: auto;
  margin-bottom:10px;

`;

const Body = styled("div")`
  height: 80vh;
  width:1300px;
  margin-bottom:10px;
`;

const Date = styled("div")`
  margin:20px 0px 10px 0;
  font-weight : bold;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  margin-top: 1rem;
  display: grid;
  column-gap: 0.7rem;
  grid-template-columns: minmax(0,1.4fr) minmax(0,1.8fr) minmax(0,1.8fr) minmax(0,2fr) minmax(0,1.3fr) minmax(0,2.3fr) minmax(0,1.0fr)  minmax(0,0.8fr);
  align-items: center;
  font-size:14px
`;


